import React, { Component } from 'react';
import {Link} from 'react-router-dom';
class Footer extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {
    // Check if jQuery is loaded
    if (!window.$) {
      console.error('jQuery is not loaded. Ensure it is available globally.');
      return;
    }

    const $ = window.$; // Use jQuery from global context


    // Back to top button
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        $('.back-to-top').fadeIn('slow');
      } else {
        $('.back-to-top').fadeOut('slow');
      }
    });

    $('.back-to-top').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 1500, 'easeInOutExpo');
      return false;
    });
  }

  componentWillUnmount() {
    // Remove event listeners when the component unmounts
    const $ = window.$;
    $(window).off('scroll');
    $('.back-to-top').off('click');
  }



  render() {
    return (
        <>
          {/*<!-- Footer Start -->*/}
        <div className="container-fluid bg-dark text-white-50 footer pt-5 wow fadeIn footer_color" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="row g-5">
               {/*     <div className="col-lg-3 col-md-6">
                        <h5 className="text-white mb-4">Company</h5>
                        <Link to="/aboutus" className="btn btn-link text-white-50">About Us</Link>
                        <Link to="/contact" className="btn btn-link text-white-50">Contact Us</Link>
                        <Link to="/services" className="btn btn-link text-white-50">Our Services</Link>
                        <Link to="/privacy" className="btn btn-link text-white-50">Privacy Policy</Link>
                        <Link to="/terms" className="btn btn-link text-white-50">Terms of Use</Link>
                    </div>*/}
                    <div className="col-lg-4 col-md-6">
                        <h5 className="text-white mb-4">Quick Links</h5>
                        <Link to="/privacy" className="btn btn-link text-white-50">Privacy Policy</Link>
                        <Link to="/terms" className="btn btn-link text-white-50">Terms of Use</Link>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <h5 className="text-white mb-4">Contact</h5>
                        <p className="mb-2 d-flex align-items-start">
                          <i className="fa fa-map-marker-alt me-3 mt-1"></i>
                          <span>
                            Unit No. 3106, 3rd Floor, Wing-W, Akshar Business Park, Janta Market Rd,
                            opposite APMC Fruits and Vegetable Market, Sector 25, Vashi,
                            Navi Mumbai, Maharashtra 400703
                          </span>
                        </p>
                        <p className="mb-2"><i className="fa fa-phone-alt me-3"></i>+91-7738789456</p>
                        <p className="mb-2"><i className="fa fa-envelope me-3"></i>Info@bylawslegal.com</p>
                        <div className="d-flex pt-2">
                            <a className="btn btn-outline-light btn-social" href="mailto:info@bylawslegal.com"><i className="fas fa-envelope"></i></a>
                            <a className="btn btn-outline-light btn-social" href="https://x.com/BYLAWSLEGAL" target="_blank"><i className="fab fa-twitter"></i></a>
                            <a className="btn btn-outline-light btn-social" href="https://www.facebook.com/profile.php?id=61588555565850" target="_blank"><i className="fab fa-facebook-f"></i></a>
                                <a className="btn btn-outline-light btn-social" href="https://www.instagram.com/bylaws_legal/?hl=en" target="_blank"><i className="fab fa-instagram"></i></a>
                            <a className="btn btn-outline-light btn-social" href="https://www.youtube.com/@Bylawslegal" target="_blank"><i className="fab fa-youtube"></i></a>
                            <a className="btn btn-outline-light btn-social" href=""><i className="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      {/*  <h5 className="text-white mb-4">Newsletter</h5>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                        <div className="position-relative mx-auto newslatter-div">
                            <input className="form-control bg-transparent w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                            <button type="button" className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
                        </div>
                        */}
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="copyright">
                    <div className="row">
                        <div className="col-md-12 text-center mb-3 mb-md-0">
                            &copy; <a className="border-bottom" href="/"><b>Bylaws</b> Legal LLP</a>, All Right Reserved.

                        </div>

                    </div>
                </div>
            </div>
        </div>
        {/*<!-- Footer End -->*/}


       {/* <!-- Back to Top -->*/}
        <a href="#" className="btn btn-lg btn-primary btn-lg-square back-to-top"><i className="bi bi-arrow-up"></i></a>
        </>
    );
  }
}

export default Footer;
